export enum FeedbackStages {
  Initial = 'Initial',
  Confirmation = 'Confirmation',
  Form = 'Form',
}
